<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->
@if (displayDialog()) {
  <p-dialog header="{{'dispatcher.tasks.details' | translate}}"
            [visible]="displayDialog()"
            (visibleChange)="displayDialog.set($event)"
            [modal]='true'
            [draggable]='false'
            [resizable]='false'
            [style]="{'width': '40vw', 'min-width': '400px', 'max-width': '700px'}"
            class='fit-content-popup condensed'>
    <well-task-tracking-details [task]="task()"></well-task-tracking-details>
  </p-dialog>
}


